var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5F62\u72B6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "58.7200081%",
    x2: "0%",
    y2: "58.7200081%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    stopOpacity: 0.698153409,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20220317\\u4E1A\\u7EE9\\u6307\\u6807\\u5C55\\u793A",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F\\u5907\\u4EFD-46",
    transform: "translate(-663.000000, -164.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-19",
    transform: "translate(646.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6",
    transform: "translate(17.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.17,19.0168794 C4.94313958,19.0173977 4.73125447,18.9011011 4.60625,18.7074543 L3.23125,16.7524613 L0.6875,16.7524613 C0.307804234,16.7524613 0,16.4376123 0,16.0492264 C0,15.6608405 0.307804234,15.3459916 0.6875,15.3459916 L3.63,15.3459916 C3.8574947,15.3428464 4.07053323,15.4597761 4.19375,15.6554149 L5.06,16.907173 L6.435,14.0098453 C6.53534381,13.778233 6.75182718,13.621606 6.99875,13.6019691 C7.24372108,13.5872666 7.47838446,13.7046166 7.6175,13.9113924 L8.9925,16.0351617 L11.45375,16.0351617 C11.8334458,16.0351617 12.14125,16.3500107 12.14125,16.7383966 C12.14125,17.1267825 11.8334458,17.4416315 11.45375,17.4416315 L8.70375,17.4416315 C8.47688958,17.4421516 8.26500447,17.325855 8.14,17.1322082 L7.19125,15.7257384 L5.81625,18.6230661 C5.71207069,18.8492095 5.49633629,18.9999123 5.2525,19.0168794 L5.17,19.0168794 Z M20.735,21 L18.3425,21 C17.6438598,21 17.0775,20.4206779 17.0775,19.7060478 L17.0775,11.2672293 C17.0775,10.5525992 17.6438598,9.97327707 18.3425,9.97327707 L20.735,9.97327707 C21.4336402,9.97327707 22,10.5525992 22,11.2672293 L22,19.7060478 C22,20.4206779 21.4336402,21 20.735,21 L20.735,21 Z M18.4525,19.5935302 L20.625,19.5935302 L20.625,11.4219409 L18.4525,11.4219409 L18.4525,19.5935302 Z M13.54375,14.2770745 L11.1375,14.2770745 C10.4464537,14.2770745 9.88625,13.7040494 9.88625,12.9971871 L9.88625,4.5583685 C9.88625,3.84919521 10.4442354,3.27212472 11.1375,3.26441632 L13.54375,3.26441632 C14.2370146,3.27212472 14.795,3.84919521 14.795,4.5583685 L14.795,12.9971871 C14.795,13.7040494 14.2347963,14.2770745 13.54375,14.2770745 L13.54375,14.2770745 Z M11.26125,12.8706048 L13.42,12.8706048 L13.42,4.69901547 L11.26125,4.69901547 L11.26125,12.8706048 Z M6.28375,11.9845288 L3.8775,11.9845288 C3.18423542,11.9768204 2.62625,11.3997499 2.62625,10.6905767 L2.62625,2.25175809 C2.64830747,1.55907889 3.19999658,1.00716576 3.8775,1 L6.28375,1 C6.97701458,1.0077084 7.535,1.58477889 7.535,2.29395218 L7.535,10.7327707 C7.51294253,11.4254499 6.96125342,11.9773631 6.28375,11.9845288 L6.28375,11.9845288 Z M4.00125,10.5780591 L6.16,10.5780591 L6.16,2.40646976 L4.00125,2.40646976 L4.00125,10.5780591 Z"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.423a85e6899399f0ec175a26ac1eee74.svg";
export { ForwardRef as ReactComponent };